<script>
	import Select from "svelte-select";

	export let items = [];
	export let error = false;
	export let errorText = "";
	export let placeholder = "";
	export let value = "";
	export let containerClasses = "";
	export let onInput = () => {};
	export let onChange = () => {};
	export let handleClear = () => {};
	export let onSelect = () => {};
	export let loadOptions = undefined;
	export let errorBorder = false;
	export let isClearable = true;
	export let isSearchable = true;
	export let chevron = false;
</script>

<div class="dropdown-chevron-wrapper">
	<Select
		type="text"
		bind:value
		{items}
		{loadOptions}
		hasError={error}
		containerClasses={`form-select getgo select ${error ? "danger" : ""} ` +
			containerClasses}
		{placeholder}
		on:input={onInput}
		onChange={onInput}
		{handleClear}
		{isClearable}
		{isSearchable}
		on:select={onSelect}
		inputStyles={`color: var(--fds-on-surface-variant); padding: 0 ${
			containerClasses === "" ? "12px" : "32px"
		};`}
		noOptionsMessage={"No result"}
	/>
	{#if chevron}
		<span class="dropdown-chevron" />
	{/if}
</div>

{#if error}
	<small class="error-text">{errorText}</small>
{/if}

<style>
	:global(.svelte-17l1npl)::placeholder {
		font-family: "DM Sans", system-ui !important;
	}

	.error-border {
		border: 1px solid var(--fds-danger) !important;
	}

	.dropdown-chevron-wrapper {
		position: relative;
		width: 100%;
	}

	.search-logo {
		padding-left: 34px;
	}

	:global(.selectContainer.svelte-17l1npl input.svelte-17l1npl::placeholder) {
		color: var(--fds-on-surface-variant) !important;
	}
	:global(.selectContainer.focused.svelte-17l1npl.svelte-17l1npl) {
		border: 1.5px solid var(--fds-primary) !important;
	}
	.dropdown-chevron-wrapper {
		position: relative;
		width: 100%;
	}

	.dropdown-chevron {
		pointer-events: none;
		position: absolute;
		right: 16px;
		top: 50%;
		transform: translateY(-50%);
		width: 20px;
		height: 20px;
		background-image: url("/assets/icon-chevron-down.png");
		background-repeat: no-repeat;
		background-size: 20px 20px;
	}
</style>
